import { Device } from '@helpers/media';
import React from 'react';
import s from './Grid.styles';
export var GridColumns;
(function (GridColumns) {
    GridColumns[GridColumns["Half"] = 0] = "Half";
    GridColumns[GridColumns["Third"] = 1] = "Third";
    GridColumns[GridColumns["Quarter"] = 2] = "Quarter";
})(GridColumns || (GridColumns = {}));
export const Grid = ({ children, collapseAtViewport = Device.MobileLarge, split, }) => {
    return (React.createElement(s.Container, { collapse: collapseAtViewport, columns: split }, children));
};
export const Column = ({ children }) => React.createElement(s.Column, null, children);
